import React, { useEffect } from 'react'
import About from '../components/about'
import Reputation from '../components/reputation'


export default function AboutUs() {
  useEffect(() => {
      window.scrollTo(0, 0)
    }, [])
  return (
    <div className='py-10 md:py-0'>
      <About />
      <Reputation/>
    </div>
  )
}
